export default interface ShiftTeamRepositoryInterface {
  getAllShiftTeams(departmentId: string, date: Date): Promise<ShiftTeamInterface[]>

  createShiftTeam(data: ApiCreateShiftTeamInterface): Promise<boolean>

  deleteShiftTeam(id: number): Promise<void>

  getUserShiftStatistics(userId: string, date: Date): Promise<void>
}

export interface ShiftTeamInterface {
  id: number
  departmentId: string
  date: Date
  shiftTeamUsers: ShiftTeamUserInterface[]
  teamId?: number
}

export interface ShiftTeamUserInterface {
  id?: number
  userId: string
  userType: ShiftTeamUserType
  teamId?: number
  details?: {
    firstName: string,
    lastName: string,
  }
}

export interface ShiftTeamUserWithShiftsInterface extends ShiftTeamUserInterface {
  shifts?: any
}

export enum ShiftTeamUserType {
  USER = 0,
  DEPUTY_SHIFT_LEADER = 1,
  SHIFT_LEADER = 2,
}

export interface ApiCreateShiftTeamInterface {
  id?: number
  departmentId: string
  date: Date
  shiftTeamUsers: ShiftTeamUserInterface[]
}

export interface ShiftCalendarUserInterface {
  id: number
  departmentId: string
  date: Date
  shiftTeamUsers?: ShiftTeamUserWithShiftsInterface[]
  shifts?: any
  teamId?: number
}
